import { Tooltip } from 'react-tooltip'

import EditIcon from '../../assets/images/icons/edit-01.svg?react'
import InfoIcon from '../../assets/images/icons/info-circle.svg?react'
import SmartPriceLink from '../menu/items/smart-price-link'

interface ProductCardSPProps {
  productId: number
  ruleSetID?: string
  ruleText?: string
  className?: string
}

function ProductCardSP({
  productId,
  ruleSetID,
  ruleText,
  className,
}: ProductCardSPProps): JSX.Element {
  return (
    <h1
      className={`font-medium text-lg text-gray-900 leading-7 flex items-center${className ? ' ' + className : ''}`}
    >
      Smart Price
      {ruleText ? (
        <>
          <InfoIcon
            data-tooltip-id={`smartprice-tooltip-${productId}`}
            className="ml-1 cursor-pointer w-[1.1em] [&>path]:stroke-gray-700"
          />
          <Tooltip
            id={`smartprice-tooltip-${productId}`}
            positionStrategy="fixed"
            className="z-[999]"
            style={{ pointerEvents: 'all' }}
            delayHide={800}
          >
            <div
              className="w-40"
              dangerouslySetInnerHTML={{
                __html: ruleText,
              }}
            ></div>
          </Tooltip>
        </>
      ) : (
        <></>
      )}
      {ruleSetID ? (
        <>
          <Tooltip
            id={`smartprice-edit-tooltip-${productId}`}
            positionStrategy="fixed"
            className="z-[999]"
          >
            <div className="w-40">Edit SmartPrice Rule</div>
          </Tooltip>
          <SmartPriceLink
            className="flex-nowrap cursor-pointer"
            to={`/dynamic-pricing/edit-rule/${ruleSetID}`}
          >
            <EditIcon
              data-tooltip-id={`smartprice-edit-tooltip-${productId}`}
              className="pl-1 w-[1.15em] [&>path]:stroke-gray-700"
            />
          </SmartPriceLink>
        </>
      ) : (
        <></>
      )}
    </h1>
  )
}

export default ProductCardSP
